import westPassageSource from "./west-passage-source.json";
import westGrottoSource from "./west-grotto-source.json";
import runeHollowSource from "./rune-hollow-source.json";
import deepGallerySource from "./deep-gallery-source.json";

const TILE_SIZE = 32;

const normalizeRect = (object) =>
  Object.freeze({
    x: Number(object.x || 0),
    y: Number(object.y || 0),
    width: Number(object.width || 0),
    height: Number(object.height || 0),
  });

const rectanglesOverlap = (left, right) =>
  left.x < right.x + right.width &&
  left.x + left.width > right.x &&
  left.y < right.y + right.height &&
  left.y + left.height > right.y;

export const buildCavernMapConfig = (source) => {
  const navigationObjects =
    source.layers.find(
      (layer) => layer.type === "objectgroup" && layer.name === "Navigation",
    )?.objects || [];

  const entranceObject = navigationObjects.find(
    (object) => object.type === "entrance",
  );
  const entranceRect = entranceObject ? normalizeRect(entranceObject) : null;

  const exitRects = Object.freeze(
    navigationObjects
      .filter((object) => object.type === "exit")
      .reduce(
        (rects, object) => ({
          ...rects,
          [object.name]: normalizeRect(object),
        }),
        {},
      ),
  );

  const bridgeRects = Object.freeze(
    navigationObjects
      .filter((object) => object.type === "bridge")
      .map((object) => normalizeRect(object)),
  );

  const entrySpawn = entranceRect
    ? Object.freeze({
        x: entranceRect.x + entranceRect.width / 2,
        y: entranceRect.y - TILE_SIZE * 1.5,
      })
    : null;

  const walkableRects = [
    ...(entranceRect ? [entranceRect] : []),
    ...Object.values(exitRects),
    ...bridgeRects,
  ];

  const isNavigationTileWalkable = (tileX, tileY) => {
    const tileRect = {
      x: Number(tileX) * TILE_SIZE,
      y: Number(tileY) * TILE_SIZE,
      width: TILE_SIZE,
      height: TILE_SIZE,
    };
    return walkableRects.some((rect) => rectanglesOverlap(tileRect, rect));
  };

  const isBridgePoint = (x, y) =>
    bridgeRects.some(
      (rect) =>
        Number(x) >= rect.x &&
        Number(x) <= rect.x + rect.width &&
        Number(y) >= rect.y &&
        Number(y) <= rect.y + rect.height,
    );

  return Object.freeze({
    source,
    entranceRect,
    exitRects,
    bridgeRects,
    entrySpawn,
    isNavigationTileWalkable,
    isBridgePoint,
  });
};

export const WEST_PASSAGE_MAP_CONFIG = buildCavernMapConfig(westPassageSource);
export const WEST_GROTTO_MAP_CONFIG = buildCavernMapConfig(westGrottoSource);
export const RUNE_HOLLOW_MAP_CONFIG = buildCavernMapConfig(runeHollowSource);
export const DEEP_GALLERY_MAP_CONFIG = buildCavernMapConfig(deepGallerySource);
